import { PropsWithChildren } from 'react'

import { Box, Square } from 'styled-system/jsx'

import logoImg from './logo-gradient.svg'

const bgImageStyle = {
  backgroundImage: `url(${logoImg.src})`,
}

export function LayoutBlackWithLogo({ children }: PropsWithChildren) {
  return (
    <Box
      position='absolute'
      inset='0'
      padding='16'
      backgroundColor='gray.11'
      bgGradient='to-b'
      gradientFrom='black/60'
      gradientTo='black/96'
    >
      <Square
        width='full'
        height='full'
        backgroundSize='contain'
        backgroundRepeat='no-repeat'
        backgroundPosition='center'
        style={bgImageStyle}
      >
        {children}
      </Square>
    </Box>
  )
}
